import { render } from "./scheme.vue?vue&type=template&id=7cd5bfbd&scoped=true"
import script from "./scheme.vue?vue&type=script&lang=js"
export * from "./scheme.vue?vue&type=script&lang=js"

import "./scheme.vue?vue&type=style&index=0&id=7cd5bfbd&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd5bfbd"]])

export default __exports__